import { useEffect } from "react";
const forbiddenKeyCodes = [220, 222, 192];

// Override flag to control when the global listener should be active
let isOverrideEnabled = false;

export const enableOverride = () => {
  isOverrideEnabled = true;
};

export const disableOverride = () => {
  isOverrideEnabled = false;
};

const useEnterToNavigateInputs = () => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      // Skip the global handler if override is enabled
      if (isOverrideEnabled) return;

      const activeElement = document.activeElement;
      if (forbiddenKeyCodes.includes(event.keyCode) && event.key !== "'") {
        event.preventDefault();
      }

      // Handle Enter key
      if (event.key === "Enter") {
        const isAutocompleteInput = activeElement.closest(
          ".MuiAutocomplete-root"
        );
        const isDropdownOpen = document.querySelector(
          '.MuiAutocomplete-popper[style*="display: block"]'
        );

        // Handle Enter key when focused on Autocomplete and dropdown is closed
        if (isAutocompleteInput && !isDropdownOpen) {
          event.preventDefault();
          focusNextInputElement(activeElement);
        } else if (!isAutocompleteInput) {
          // If not in Autocomplete, handle Enter for other inputs (like checkboxes or text inputs)
          handleEnterOutsideAutocomplete(activeElement);
        }
      }

      // Arrow Down key for Autocomplete dropdown
      if (
        event.key === "ArrowDown" &&
        activeElement.closest(".MuiAutocomplete-root")
      ) {
        event.preventDefault();
        activeElement.click();
      }
    };

    const focusNextInputElement = (currentElement) => {
      const inputElements = Array.from(
        document.querySelectorAll(
          'input:not([disabled]):not([type="hidden"]), textarea:not([disabled])'
        )
      );
      let currentIndex = inputElements.indexOf(currentElement);

      // Focus the next input element in the arraynpm
      if (currentIndex !== -1) {
        let nextElement = inputElements[currentIndex + 1];
        while (nextElement && nextElement.hasAttribute("disabled")) {
          nextElement = inputElements[++currentIndex + 1];
        }
        if (nextElement) {
          nextElement.focus();
        }
      }
    };
    const handlePaste = (event) => {
      if (isOverrideEnabled) return;

      const clipboardData = event.clipboardData || window.clipboardData;
      const pastedText = clipboardData.getData("text");

      if (pastedText.includes('"')) {
        event.preventDefault();
      }
    };
    const handleEnterOutsideAutocomplete = (currentElement) => {
      if (currentElement.getAttribute("type") === "checkbox") {
        currentElement.click();
        focusNextInputElement(currentElement);
      } else {
        focusNextInputElement(currentElement);
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("paste", handlePaste);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("paste", handlePaste);
    };
  }, []);
};

export default useEnterToNavigateInputs;
